<script>
  import { onMount } from 'svelte';
  import { domainName, record } from '../stores.js';
  import { hasError, countDNS, recursiveError } from '../util';

  let allText = '';
  let noRecordFound = hasError($record.errors, 'No SPF Record');
  let invalidRecord  = hasError($record.errors, 'Invalid SPF record');
  let mechanismErrors = [];
  let spfErrorMessage = [];
  let dnsCount = 0;
  let dnsCountError = false;
  let showMeaning = false;

  onMount(() => {

    const allOptions = {
      '-all': 'The sender is highly confident that this SPF record is complete and accurate; they have instructed email receivers to take actions on emails from this domain based on the results of the SPF check—either positive where there is increased reputation if the SPF check is passed or negative where there is decreased reputation or the message is blocked if the SPF check fails.',
      '~all': 'The sender believes this SPF record is complete and accurate, but they require more evaluation before they can instruct email receivers to block messages based on an SPF failure. However, this sender does allows email receivers to use the SPF results to assess reputation.',
      '?all': 'The sender is not confident that this SPF record is complete or accurate for this domain. There are likely additional legitimate sources of messages which are unknown to the sender and not captured in this SPF record. This record is too weak for an email receiver to use for any type of assessment of the domain\'s email.',
    };

    const re = /\-all|\~all|\?all$/;
    const match = $record.raw.match(re);
    if (match != null) {
      allText = allOptions[match[0]];
    }

    mechanismErrors = recursiveError($record.mechanisms);
    dnsCount = countDNS($record.mechanisms);
    // console.log(mechanismErrors, 'mechanismErrors');
    if (noRecordFound) {
      showMeaning = true;
      spfErrorMessage.push('<h5>No SPF record found for: <a class="link-arrow" href="https://' + $domainName + '">' + $domainName + '</a></h5>');
      spfErrorMessage.push('p>This domain does not have an SPF record.</p>');
    }
    else if (invalidRecord) {
      showMeaning = true;
      spfErrorMessage.push('An Invalid SPF record was found for: ' + $domainName);
    }
    else {
      if (mechanismErrors.length > 0) {
        showMeaning = true;
        spfErrorMessage = [...mechanismErrors];
      }
      if (dnsCount > 10) {
        showMeaning = true;
        spfErrorMessage.push('This record includes more than 10 DNS querying mechanisms/modifiers.');
      }
    }
  });

</script>

<div class="record-box record-raw">
  <div id="headingRaw" class="box-label">
    <h5>Results</h5>
    <button type="button" class="btn-collapse" data-toggle="collapse" data-target="#collapseRaw" aria-expanded="true" aria-controls="collapseRaw" aria-label="Close"></button>
  </div>
  <div id="collapseRaw" class="box-detail collapse show" aria-labelledby="headingRaw">
    <ul class="record-list">
      <li>This SPF record authorizes {$record.ipv4_count} IPv4 addresses and {$record.ipv6_count} IPv6 addresses to send email on behalf of {$domainName}.</li>
      <li>This record includes {$record.mechanisms_count} DNS querying mechanisms/modifiers. Note that SPF imposes a maximum of 10.</li>
      <li>{allText}</li>
      <li>
        {#if spfErrorMessage.length > 0}
          Errors have been detected with this record.
          <ul>
            {#each spfErrorMessage as error}
            <li>
              {error}
            </li>
            {/each}
          </ul>
        {:else}
          No errors were encountered with this record.
        {/if}
      </li>
    </ul>
  </div>
</div>

{#if showMeaning}
<div class="record-box about-spf">
  <div class="box-label">
    <h5>Learn More About SPF></h5>
  </div>
  <div class="box-detail">
    <h6 class="font-weight-bold">How Does an SPF Record Work?</h6>
    <p>An SPF record with no errors is a good first step—it means that the domain is considering best practices for authenticating the email it sends. That said, a sender needs to <a href="/resources/dmarc">publish a DMARC record</a> to view data for the domain and to ensure the SPF record is complete and accurate. In other words, a sender is not completely protecting its brand without an accompanying DMARC policy.</p>
    <h6 class="font-weight-bold">What Happens if There is No SPF Record?</h6>
    <p>Be careful! A domain without an SPF record is basically an unprotected domain-meaning that anyone can easily spoof email from this domain. Authorizing the sources that are allowed to send email for the domain by creating a SPF record is one of the first, basic steps that senders need to take to protect themselves from abuse.</p>
    <p>
      <button id="need-analysis-spf-p2" class="btn btn-default btn-lg">Need more analysis?</button>
    </p>
  </div>
</div>
{/if}
<style>

</style>
